// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WOtN","colBig":"styles_colBig__2Arp1","colSmall":"styles_colSmall__x-8UX"};